import { render, staticRenderFns } from "./AltertPresionArterial.vue?vue&type=template&id=1bd6f934&scoped=true&"
import script from "./AltertPresionArterial.vue?vue&type=script&lang=js&"
export * from "./AltertPresionArterial.vue?vue&type=script&lang=js&"
import style0 from "./AltertPresionArterial.vue?vue&type=style&index=0&id=1bd6f934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd6f934",
  null
  
)

export default component.exports